<template>
    <div class="NameAndIssue">
          <div class="card-secondary-name">
            <p class="text-xxxl text-bold2 nama">{{this.$route.params.name}}</p>
          </div>
          <div class="card-primary">
            <div class="row text-center">
              <div class="col-3">
                <p class="text-xxxl text-bold total-projects">{{ totalProject}}</p>
                <p class="text-xxl text-bold">Projects</p>
              </div>
              <div class="col-3">
                <p class="text-xxxl text-bold total-open">{{ summary.New + summary.Feedback + summary["In Progress"] }}</p>
                <p class="text-xxl text-bold">Issue</p>
              </div>
              <div class="col-6">
                <img class="img-icon-profile" src="@/assets/antarmuka-user/img/user_interface_.png" alt="">
              </div>
            </div>
          </div>

          <div class="row text-center">

            <div class="col-4">
              <div class="card-blue-small">
                <img class="img-icon mb-20" src="@/assets/antarmuka-user/img/checklist_.png" alt="">
                <p class="text-xl text-bold">New</p>
                <br>
                <p class="text-big text-bold total-new">{{summary.New}}</p>
              </div>
            </div>
            <div class="col-4">
              <div class="card-yellow-small">
                <img class="img-icon mb-20" src="@/assets/antarmuka-user/img/user_interface_.png" alt="">
                <p class="text-xl text-bold">In Progress</p>
                <br>
                <p class="text-big text-bold total-inprogress">{{summary["In Progress"]}}</p>
              </div>
            </div>
            <div class="col-4">
              <div class="card-green-small">
                <img class="img-icon mb-20" src="@/assets/antarmuka-user/img/completed_task_.png" alt="">
                <p class="text-xl text-bold">Closed</p>
                <br>
                <p class="text-big text-bold total-closed">{{summary.Closed}}</p>
              </div>
            </div>

          </div>

        </div>
</template>


<script>

export default {
    name:"NameAndIssue",
    props: ['summary','totalProject']
}
</script>

<style scoped>
   .text-bold2 {
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/User/NameAndIssue.vue